// import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import test from './modules/test';
import algolia from './modules/algolia';
import usedProduct from './modules/usedProduct';
import analytics from './modules/analytics';
import { createOnMyAccountClicked } from '../data/OnLoginActionParams';

Vue.use(Vuex);

if (!window.customerStore){
  window.customerStore = new Vuex.Store({
    modules: {
      user,
      test,
      algolia,
      usedProduct,
      analytics
    }
  });
}

export const store = window.customerStore

export const globalActions = {

    onNavMyAccountClicked(event) {
      event.preventDefault();

      if (store.getters["user/isGuest"]){
        if (window.openLogin) {
          window.openLogin(createOnMyAccountClicked(), () => {
            window.location.href = "/customer"
          })
        }
      } else {
        window.location.href = "/customer"
      }
    },

    setIsGuest(isGuest) {
      store.commit("user/SET_IS_GUEST", isGuest)
    }
}

window.globalActions = globalActions



// WEBPACK FOOTER //
// ./resources/js/store/index.js